import axios from "axios";
import { useEffect, useState } from "react";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, timeout: 15000 });

export const isAbort = (e) => axios.isCancel(e);

export function useApi(path, params) {
  const key = JSON.stringify([path, params]);
  const [state, setState] = useState({ data: null, error: null, loading: true });

  useEffect(() => {
    const ctrl = new AbortController();
    setState((s) => ({ ...s, loading: true, error: null }));
    api
      .get(path, { params, signal: ctrl.signal })
      .then((r) => setState({ data: r.data, error: null, loading: false }))
      .catch((e) => {
        if (!isAbort(e)) setState({ data: null, error: e.response?.status === 404 ? "not_found" : "error", loading: false });
      });
    return () => ctrl.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return state;
}
